// this boolean check function receives string and returns boolean 
export const booleanCheck = (b: string) => {
  if (typeof b !== 'string') return true
  if (b.trim() === '') return true
  return b !== 'false'
}